import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M5.366 6.192a.598.598 0 0 1-.6-.592.6.6 0 0 1 .6-.6c.336 0 .6.264.6.6a.592.592 0 0 1-.6.592Zm-1.096.964a.3.3 0 0 1 .3-.3h1.032a.3.3 0 0 1 .3.3v3.656a.3.3 0 0 1-.3.3H5.21a.3.3 0 0 1-.3-.3v-2.92a.3.3 0 0 0-.3-.3h-.04a.3.3 0 0 1-.3-.3v-.136Zm-.174 7.036a.598.598 0 0 1-.6-.592.6.6 0 0 1 .6-.6c.336 0 .6.264.6.6a.592.592 0 0 1-.6.592ZM3 15.156a.3.3 0 0 1 .3-.3h1.032a.3.3 0 0 1 .3.3v3.656a.3.3 0 0 1-.3.3H3.94a.3.3 0 0 1-.3-.3v-2.92a.3.3 0 0 0-.3-.3H3.3a.3.3 0 0 1-.3-.3v-.136ZM6.035 13.6c0 .328.272.592.6.592.336 0 .6-.264.6-.592 0-.336-.264-.6-.6-.6a.6.6 0 0 0-.6.6Zm-.195 1.256a.3.3 0 0 0-.3.3v.136a.3.3 0 0 0 .3.3h.04a.3.3 0 0 1 .3.3v2.92a.3.3 0 0 0 .3.3h.391a.3.3 0 0 0 .3-.3v-3.656a.3.3 0 0 0-.3-.3H5.84ZM9.75 5.25a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H9.75Zm0 6a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H9.75ZM9 18a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 0 1.5H9.75A.75.75 0 0 1 9 18Z';
const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TextListLowercaseRomanIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'textListLowercaseRoman')) as IconWithRender;

TextListLowercaseRomanIcon.displayName = 'TextListLowercaseRomanIcon';
TextListLowercaseRomanIcon.propTypes = Icon.propTypes;
TextListLowercaseRomanIcon.renderIcon = (props) => (
  <TextListLowercaseRomanIcon {...props} />
);
export default TextListLowercaseRomanIcon;
